export { ExtractionMethodWrapper } from './ExtractionMethodWrapper';
